import {
  UPDATE_TOKEN,
  UPDATE_USER_INFO,
  UPDATE_PERMISSIONS_LIST,
  UPDATE_PERMISSIONS,
  UPDATE_BUSINESSTYPE,
  UPDATE_TASKTYPE
} from './mutation-types'
import { getToken, getUserInfo, permissionsList, xj_getSelect } from 'admin/api'
export default {
  [UPDATE_TOKEN]: ({ commit }) => getToken().then(token => {
    commit(UPDATE_TOKEN, token)
    return token
  }),
  /**
   * 更新用户信息
   */
  [UPDATE_USER_INFO]: ({ commit }) => getUserInfo().then(data => {
    const { user, permissions } = data
    commit(UPDATE_USER_INFO, user)
    commit(UPDATE_PERMISSIONS, permissions)
    return data
  }),
  /**
   * 获取所有权限的设置
   */
  [UPDATE_PERMISSIONS_LIST]: ({ commit }) => permissionsList().then(data => {
    commit(UPDATE_PERMISSIONS_LIST, data)
    return data
  }),
  [UPDATE_BUSINESSTYPE]: ({ commit }) => xj_getSelect().then(data => {
    commit(UPDATE_BUSINESSTYPE, data.business_type)
    return data
  }),
  [UPDATE_TASKTYPE]: ({ commit }) => xj_getSelect().then(data => {
    commit(UPDATE_TASKTYPE, data.task_type)
    return data
  })
}
